import { BrowserRouter, Route, Routes, Navigate, Redirect   } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Monitor from './pages/Monitor';
import Concierge from './pages/Concierge';
import Access from './pages/Access';
import Time from './pages/Time';
import AI from './pages/AI';
import Construction from './pages/Construction';
import IndustryPage from './pages/IndustryPage';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Company from './pages/Company';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
    <div>
      <Navbar />
      <ScrollToTop />
      <div className="content">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
         <Route path="/services/remote-monitoring" element={<Monitor />} />

         <Route path="/services/remote-concierge" element={<Concierge />} />
         <Route path="/services/remote-access-management" element={<Access />} />
         <Route path="/services/time-lapse-monitoring" element={<Time />} />
         <Route path="/services/ai-powered-security" element={<AI />} />
          <Route path="/industry/construction" element={<Construction />} />
        <Route path="/services/:serviceId" element={<ServiceDetail />} />
        <Route path="/industries/:slug" element={<IndustryPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/company" element={<Company />} />
      </Routes>
      </div>
    <Footer/>
    </div>
    </BrowserRouter>
  );
}

export default App;
